import script from "./ProfileLoRaWANForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileLoRaWANForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__